export const COOKIE = {
  JSESSIONID: 'JSESSIONID',
  AWSALB: 'AWSALB',
  AWSALBCORS: 'AWSALBCORS',
  BOOKMARKID: 'BOOKMARKID',
  HISTORYID: 'HISTORYID',
  HISTORY_ID_CA: 'HISTORY_ID_CA',
  DESIRED_COND: 'desired_cond',
  DESIRED_SEARCH: 'desired_search',
  TUTOR_MODAL: 'tutorModal',
  SESSION: 'SESSION',
  SEARCH_CONDITION1: 'search_condition1',
  SEARCH_CONDITION2: 'search_condition2',
  SEARCH_CONDITION3: 'search_condition3',
  SID: 'sid',
  AUTO_LOGIN: 'auto_login',
  LATEST_SEARCH: 'latest_search',
  VIEW_MODE: 'viewmode',
  PRE_PAGE_ID: 'prePageId',
  OUTPUT_STAFF_INFO: 'output_staff_info',
  IS_PINO_TARGET: 'is_pino_target',
  IS_UPDATED_WEB_RESUME: 'is_updated_web_resume',
  IS_UPDATED_WORK_EXPERIENCE: 'is_updated_work_experience',
  IS_UPDATED_WEB_RESUME_TARGET_COUNSELING:
    'is_updated_web_resume_target_counseling',
  SP_TOP_BOTTOM_FOLLOW_NUM: 'sp_top_bottom_follow_num',
  TOP_BOOKMARK_APPEAL_MODAL_AB: 'top_bookmark_appeal_modal_ab',
  IS_NEW_MEMBER_FROM_SAVE_SEARCH_CONDITION:
    'is_new_member_from_save_search_condition',
  COMPANY_BLOCK_MIGRATION_AGREE: 'company_block_migration_agree',
  SP_TOP_FIRSTVIEW_HASH: 'sp_top_firstview_hash',
  APPLY_BUTTON_CHANGE_NUM: 'apply_button_change_num',
  T_MANUSCRIPT_SUMMARY_AB_NUM: 't_manuscript_summary_ab_num',
  COUNSELING_DISTRIBUTION_SEQ: 'counselingDistributionSeq',
  MEMBER_REGISTRATION_TMP: 'memberRegistrationTmp',
};
